<template>
  <section>
    <v-snackbar
      v-model="snackModel"
      :timeout="snakTimeOut"
      :color="snackColor"
      top
      absolute
      elevation="24"
      shaped
      content-class="alert"
      style="z-index: 999999999999999999999999999999999999999999999 !important"
    >
      <v-icon class="ml-2">{{ snakIcon }}</v-icon>
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="black"
          text
          v-bind="attrs"
          @click="snackModel = false"
          class="no-letter-space"
        >
          بستن
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<script>
  export default {
    name: 'alertDialog',
    props: {
      snakTimeOut: {
        type: Number,
        default: 10000,
      },
      snakIcon: {
        type: String,
        default: 'mdi-check-circle',
      },
      snackColor: {
        type: String,
        default: 'red',
      },
      snackText: {
        type: String,
        default: '',
      },
    },
    created() {
      this.$root.$refs.Alert = this;
    },
    mounted() {},
    beforeDestroy() {},
    data() {
      return {
        snackModel: false,
        // snakIcon:'',
        // snackColor:'',
        // snackText:''
      };
    },
    methods: {},
    computed: {},
  };
</script>
<style>
  .v-snack--absolute {
    position: fixed !important;
  }
  .snakbar-app-overlay {
    position: relative;
    z-index: 52521535321424213423142341234213431241234312423141234231414 !important;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
  }
</style>
<style scoped>
  .v-snack {
    z-index: 99999999999999999999999999999999999999999999999 !important;
  }
</style>
